import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login.service';
import { UtilsService } from '../utils.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../auth.service';
import { GenericsService } from '../generics.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public emailCadastro: string = "";
  public email: string = "";
  public senha: string = "";
  private chave:string = "";
  public vesqueciSenha: boolean = false;
  public message: string;
  public progressBar: Boolean = false;

  constructor(public router: Router,
              public route: ActivatedRoute,
              private auth: AuthService,
              private generics:GenericsService,
              private login: LoginService) {}

  ngOnInit() {
    if (this.route.snapshot.paramMap.get('chave') !== null) {
      localStorage.setItem('tokenConfirmacao', this.route.snapshot.paramMap.get('chave'));
      this.chave = this.route.snapshot.paramMap.get('chave');
    }

    if (this.auth.isLoggedIn()) {
      this.auth.logout();
    }
  }

  ngAfterViewInit() {}

  cadastrar() {
    localStorage.setItem("cadastro", this.emailCadastro);
    this.router.navigate(['/cadastro']);
  }

  enviarEmailEsqueciSenha() {
    if (this.email == ''){
      UtilsService.alerta("Favor informar o e-mail de recuperação!", "erro");
      return;
    }

    this.progressBar = true;
    this.login.recuperarSenha(this.email).subscribe((resp) => {
      this.email = "";
      this.senha = "";
      this.vesqueciSenha = false;
      this.progressBar = false;
      UtilsService.alerta("E-mail de recuperação enviado.");
      this.router.navigate(['/login']);
    }, (httpReturn) => {
      this.progressBar = false;
      if (httpReturn.error.message !== undefined)
        UtilsService.alerta(httpReturn.error.message, 'erro');
      else UtilsService.alerta("Favor verificar sua internet.", 'erro');
    });
  }

  esqueciSenha() {
    this.email = "";
    this.senha = "";
    this.vesqueciSenha = true;
  }

  voltar() {
    this.email = "";
    this.senha = "";
    this.vesqueciSenha = false;
  }

  getLogado(vcallback: any) {
    return JSON.parse(localStorage.getItem("login"));
  }

  logar() {
    if (this.vesqueciSenha == true) {
      this.enviarEmailEsqueciSenha();
      return;
    }

    if (this.email == "" || this.senha == "") {
      UtilsService.alerta("Favor digitar o e-mail e senha corretamente!", "erro");
    } else {
      this.progressBar = true;
      this.login.logar({
        "tokenConfirmacao": (localStorage.getItem('tokenConfirmacao') !== 'null' ? localStorage.getItem('tokenConfirmacao') : ''),
        "email": this.email,
        "senha": this.senha
      }).subscribe((resp) => {
        this.progressBar = false;
        this.auth.sendToken(this.email);
        localStorage.setItem('tokenConfirmacao', '');
        this.login.setUsuario(resp);

        this.generics.get('dados').subscribe((resp) => {
          UtilsService.setEnums(resp);
        })

        this.router.navigate(['/projetos']);
      }, (httpReturn) => {
        this.progressBar = false;
        if (httpReturn.error.message !== undefined)
          UtilsService.alerta(httpReturn.error.message, 'erro');
        else UtilsService.alerta("Favor verificar sua internet.", 'erro');
      });
    }
  }

}